import React from "react";
import AllCategories from "./CategoryModule/AllCategories";

const Categories = () => {
  return (
    <div>
      <AllCategories />
    </div>
  );
};

export default Categories;
